module.exports = __webpack_public_path__ + "assets/img/free_7.03105f68.png";